@if (hasMatAccess()) {
<div class="ana-wrapper">

  <!-- Expanded Bubble -->
  @if (isExpanded()) {
  <div class="ana-bubble" (click)="$event.stopPropagation()">
    <div class="ana-bubble__header">
      <div class="ana-bubble__avatar-wrap">
        <img [src]="avatarUrl" alt="Ana" class="ana-bubble__avatar-img" />
        <div class="ana-bubble__online-dot"></div>
      </div>
      <div class="ana-bubble__info">
        <div class="ana-bubble__name">Ana</div>
        <div class="ana-bubble__role">Assistente Ezfy · Especialista em Acompanhamento</div>
      </div>
      <button class="ana-bubble__minimize" (click)="onMinimize()" title="Minimizar">−</button>
    </div>

    <div class="ana-bubble__body">
      <!-- Loading -->
      @if (isLoading()) {
      <div class="ana-bubble__typing">
        <span class="ana-bubble__dot"></span>
        <span class="ana-bubble__dot"></span>
        <span class="ana-bubble__dot"></span>
      </div>
      } @else {

      <!-- With MAT Data -->
      @if (hasMatData()) {
      <p>Olá!</p>
      <p>Estamos a acompanhar a adesão ao tratamento de <span class="ana-bubble__stat">{{ monitoredCount() }} {{ monitoredCount() === 1 ? 'utente' : 'utentes' }}</span> nesta farmácia.</p>
      @if (atRiskCount() > 0) {
      <p>Hoje identifiquei <span class="ana-bubble__stat">{{ atRiskCount() }} {{ atRiskCount() === 1 ? 'utente' : 'utentes' }}</span> que {{ atRiskCount() === 1 ? 'precisa' : 'precisam' }} da vossa atenção.</p>
      }
      <p class="ana-bubble__motto">Cada utente acompanhado conta.</p>
      <button class="ana-bubble__cta" (click)="onViewDetails()">Ver detalhes →</button>
      } @else {
      <!-- No MAT Data -->
      <p>Olá!</p>
      <p><strong>Vamos acompanhar mais utentes, juntos?</strong></p>
      <p>
        Complete a medicação crónica dos utentes e ative o
        <a class="ana-bubble__inline-link" routerLink="/mat" (click)="onMatLinkClick()">MAT</a>.
      </p>
      <p class="ana-bubble__motto">Cada ativação é uma oportunidade de cuidar melhor.</p>
      }

      <!-- Suggestion Cards (if expanded and has suggestions) -->
      @if (hasSuggestions()) {
      <div class="ana-bubble__suggestions">
        @for (s of suggestions().slice(0, 3); track s.id) {
        <div class="ana-bubble__card" [class]="'ana-bubble__card--' + s.severity" (click)="onDeeplinkClick(s)">
          <div class="ana-bubble__card-header">
            <mat-icon class="ana-bubble__card-icon">{{ getSeverityIcon(s.severity) }}</mat-icon>
            <span class="ana-bubble__card-title">{{ s.title }}</span>
          </div>
          <p class="ana-bubble__card-desc">{{ s.description }}</p>
          <span class="ana-bubble__card-link">
            <mat-icon class="ana-bubble__card-link-icon">open_in_new</mat-icon>
            Ver detalhes
          </span>
        </div>
        }
        @if (totalCount() > 3) {
        <button class="ana-bubble__more-link" (click)="onViewDetails()">Ver todas as {{ totalCount() }} sugestões →</button>
        }
      </div>
      }

      }
    </div>

    <div class="ana-bubble__footer">
      Sugestões geradas automaticamente
    </div>
  </div>
  }

  <!-- Minimized Ball -->
  <div class="ana-ball" [class.ana-ball--has-unread]="unreadCount() > 0" (click)="onToggle()">
    <img [src]="avatarUrl" alt="Ana" class="ana-ball__img" />
    <div class="ana-ball__online-dot"></div>
    @if (unreadCount() > 0) {
    <div class="ana-ball__badge">{{ unreadCount() > 9 ? '9+' : unreadCount() }}</div>
    }
  </div>

</div>
}
